import React from "react";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import {Colors, IconDashboard, IconDocument, MenuListItem} from "@bounce/shared/ui";
import {IconAudiences, IconCampaigns, IconCreditCard, IconSegments} from "../assets";

export const reachUrls = {
  dashboard: "/dashboard",
  templates: "/templates",
  templatesNew: "/templates/new",
  templateById: "/templates/:id",
  snippets: "/snippets",
  snippetsNew: "/snippets/new",
  snippetById: "/snippets/:id",
  assets: "/assets",
  triggers: "/triggers",
  triggersNew: "/triggers/new",
  triggerById: "/triggers/:id",
  glossary: "/glossary",
  segments: "/segments",
  marketingSegments: "/segments/marketing",
  validationSegments: "/segments/validation",
  segmentsNew: "/segments/new",
  segmentById: "/segments/:id",
  audiences: "/audiences",
  audienceDetail: "/audiences/detail",
  campaigns: "/campaigns",
  campaignDetail: "/campaigns/detail",
  promos: "/promos",
  payments: "/payments",
  cardPaymentsRetry: "/payments/card-payments-retry",
  paymentMethodDisplay: "/payments/payment-method-display",
} as const;

export const reachMenuItems: MenuListItem[] = [
  {
    id: "dashboard",
    type: "category-item",
    title: "Dashboard",
    icon: <IconDashboard color={Colors.blue._400} size={20} />,
    url: reachUrls.dashboard,
    display: true,
  },
  {
    id: "content",
    type: "category-nest-item",
    title: "Content",
    icon: <IconDocument color={Colors.blue._400} size={20} />,
    subListItems: [
      {id: "templates", title: "Templates", url: reachUrls.templates},
      {id: "snippets", title: "Snippets", url: reachUrls.snippets},
      {id: "assets", title: "Assets", url: reachUrls.assets},
      {id: "triggers", title: "Triggers", url: reachUrls.triggers},
      {id: "glossary", title: "Glossary", url: reachUrls.glossary},
    ],
    display: true,
  },
  {
    id: "segments",
    type: "category-nest-item",
    title: "Segments",
    icon: <IconSegments width={20} height={20} color={Colors.blue._400} />,
    subListItems: [
      {id: "marketing", title: "Marketing", url: reachUrls.marketingSegments},
      {id: "validation", title: "Validation", url: reachUrls.validationSegments},
    ],
    display: true,
  },
  {
    id: "audiences",
    type: "category-item",
    title: "Audiences",
    icon: <IconAudiences width={20} height={20} color={Colors.blue._400} />,
    url: reachUrls.audiences,
    display: true,
  },
  {
    id: "campaigns",
    type: "category-item",
    title: "Campaigns",
    icon: <IconCampaigns width={20} height={20} color={Colors.blue._400} />,
    url: reachUrls.campaigns,
    display: true,
  },
  {
    id: "promos",
    type: "category-item",
    title: "Promo Board",
    icon: <LocalOfferOutlinedIcon sx={{fontSize: 20, color: Colors.blue._400}} />,
    url: reachUrls.promos,
    display: true,
  },
  {
    id: "payments",
    type: "category-nest-item",
    title: "Payments",
    icon: <IconCreditCard width={20} height={20} color={Colors.blue._400} />,
    subListItems: [
      {id: "card-payments-retry", title: "Card payments retry", url: reachUrls.cardPaymentsRetry},
      {id: "payment-method-display", title: "Payment method display", url: reachUrls.paymentMethodDisplay},
    ],
    display: true,
  },
];
